import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { rawCustomerAttributes } from '../types/models';
import { findSessionStorageByValue } from '@/composables/sessionStorageHelpers';

export const useAccountStore = defineStore('accountStore', () => {
  const rawCustomerAttributes = ref<rawCustomerAttributes>({
    attributes: {
      loginType: '',
    },
    profile: {
      id: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
    },
    recentOrders: [],
    tags: [],
  });
  const setRawCustomerAttributes = (customerObject: rawCustomerAttributes) => {
    rawCustomerAttributes.value = customerObject;
  };

  const oxiLoginIframe = ref('');
  const setOxiLoginIframe = (value: string) => (oxiLoginIframe.value = value);

  const profile = computed(() => rawCustomerAttributes.value.profile);
  const recentOrders = computed(() => rawCustomerAttributes.value.recentOrders);
  const tags = computed(() => rawCustomerAttributes.value.tags);

  const loginType = computed<null | string>(() => {
    const isLoggedIn = !!profile.value.email;
    if (!isLoggedIn) return null;
    const hasOxiSocialSessionStorage = findSessionStorageByValue('social-login.oxiapps');
    return hasOxiSocialSessionStorage === null ? 'form' : 'sso';
  });
  const attributes = computed(() => ({
    isLoggedIn: !!profile.value.email,
    loginType: loginType.value,
  }));

  return {
    setRawCustomerAttributes,
    oxiLoginIframe,
    setOxiLoginIframe,
    attributes,
    profile,
    recentOrders,
    tags,
  };
});
